import { Component, input, output } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';

import { ImageBoxLinkComponent } from '../../image-boxes/image-box-link/image-box-link.component';

@Component({
    selector: 'app-logo',
    standalone: true,
    imports: [
        ImageBoxLinkComponent
    ],
    templateUrl: './logo.component.html',
})
export class LogoComponent {
    input_url$$             = input<string | null>(null, {alias: 'url'});
    input_border$$          = input<boolean>(true, {alias: 'border'});
    input_noClick$$         = input<boolean>(false, {alias: 'noClick'});
    input_size$$            = input<string>('', {alias: 'size'});
    input_tooltip$$         = input<string>('', {alias: 'tooltip'});
    input_tooltipPosition$$ = input<TooltipPosition>('right', {alias: 'tooltipPosition'});

    onClickEmit = output<void>();
}
